<t4-container>
  <t4-data-table #tblActualPrices [rawData]="actualPrices" [allowFilter]="false" [allowPaging]="false" headline="{{ 'CC.ProductPrices.lstProductPrices' | translate : 'Active objects' }}" matSort matSortActive="ProductId" matSortDirection="asc" [autoGenerateColumns]="false">
    <ng-container matColumnDef="AddNewProductPrice">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="padding-left: 15px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 60px;">{{ 'CC.ProductPrices.AddPrice.Add' | translate : 'Add' }}</mat-header-cell>
      <mat-cell *matCellDef="let row" style="padding-left: 0px; max-width: 60px;">
        <button color="primary" mat-icon-button (click)="addPrice(row)">
          <mat-icon>add</mat-icon>
        </button></mat-cell>
    </ng-container>

    <ng-container matColumnDef="Product">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; padding-left: 15px;">{{ 'CC.ProductPrices.colProduct' | translate : 'Product' }}</mat-header-cell>
      <mat-cell *matCellDef="let row" style="padding-left: 15px;">{{ row.Product.Name }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="Price">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="text-align: center; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:150px; padding-left: 15px;">{{ 'CC.ProductPrices.colPrice' | translate : 'Price' }}</mat-header-cell>
      <mat-cell *matCellDef="let row" style="text-align: center; min-width:150px; padding-left: 15px;">{{row.Price}}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="Type">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="text-align: center; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:150px; padding-left: 15px;">{{ 'CC.ProductPrices.colType' | translate : 'Type' }}</mat-header-cell>
      <mat-cell *matCellDef="let row">
        <ng-container *ngIf="row.Type == 0" style="text-align: center; min-width:150px; padding-left: 15px;">{{ 'CC.ProductPrices.drpType.valFixed' | translate : 'Fixed' }}</ng-container>
        <ng-container *ngIf="row.Type == 1" style="text-align: center; min-width:150px; padding-left: 15px;">{{ 'CC.ProductPrices.drpType.valPercentage' | translate : 'Percentage' }}</ng-container>
        <ng-container *ngIf="row.Type == 2" style="text-align: center; min-width:150px; padding-left: 15px;">{{ 'CC.ProductPrices.drpType.valSpecified' | translate : 'Specified' }}</ng-container>
        <ng-container *ngIf="row.Type == 3" style="text-align: center; min-width:150px; padding-left: 15px;">{{ 'CC.ProductPrices.drpType.valFixedPerUnit' | translate : 'Fixed per unit' }}</ng-container>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="UseAbsoluteAmount">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="text-align: center; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:150px; padding-left: 15px;">{{ 'CC.ProductPrices.colUseAbsoluteAmount' | translate : 'Use absolute amount' }}</mat-header-cell>
      <mat-cell *matCellDef="let row" style="text-align: center; min-width:150px; padding-left: 15px;">{{row.UseAbsoluteAmount}}</mat-cell>
    </ng-container>

  </t4-data-table>
</t4-container>
<br />
<t4-container>
  <t4-data-table #tblPrices [rawData]="prices" [allowFilter]="false" [allowPaging]="false" headline="{{ 'CC.ProductPrices.lstProductPrices' | translate : 'Active objects' }}" matSort matSortActive="ProductId" matSortDirection="asc" [autoGenerateColumns]="false">
    <ng-container matColumnDef="Product">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{ 'CC.ProductPrices.colProduct' | translate : 'Product' }}</mat-header-cell>
      <mat-cell *matCellDef="let row">
        <ng-container *ngIf="row.Product">
          {{ row.Product.Name }}
        </ng-container>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="Price">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:150px;">{{ 'CC.ProductPrices.colPrice' | translate : 'Price' }}</mat-header-cell>
      <mat-cell *matCellDef="let row">
        <mat-form-field appearance="fill" style="max-width: 150px; align-content: center;">
          <mat-label>{{ 'CC.ProductPrices.colPrice' | translate : 'Price' }}</mat-label>
          <input matInput [(ngModel)]="row.Price" />
        </mat-form-field>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="Type">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:150px;">{{ 'CC.ProductPrices.colType' | translate : 'Type' }}</mat-header-cell>
      <mat-cell *matCellDef="let row">
        <mat-form-field style="max-width: 150px">
          <mat-select [(ngModel)]="row.Type">
            <mat-option [value]="0">{{ 'CC.ProductPrices.drpType.valFixed' | translate : 'Fixed' }}</mat-option>
            <mat-option [value]="1">{{ 'CC.ProductPrices.drpType.valPercentage' | translate : 'Percentage' }}</mat-option>
            <mat-option [value]="3">{{ 'CC.ProductPrices.drpType.valFixedPerUnit' | translate : 'Fixed per unit' }}</mat-option>
          </mat-select>
        </mat-form-field>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="UseAbsoluteAmount">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:150px;">{{ 'CC.ProductPrices.colUseAbsoluteAmount' | translate : 'Use absolute amount' }}</mat-header-cell>
      <mat-cell *matCellDef="let row">
        <mat-checkbox [(ngModel)]="row.UseAbsoluteAmount"></mat-checkbox>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="Delete">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="max-width: 110px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{ 'Turbo_Fleet_RentalObjects.Remove' | translate : 'Remove' }}</mat-header-cell>
      <mat-cell *matCellDef="let row" style="padding-left: 15px; max-width: 110px;">
        <button color="primary" mat-icon-button (click)="removeObject(row)">
          <mat-icon>delete</mat-icon>
        </button>
      </mat-cell>
    </ng-container>

  </t4-data-table>

 <div style="text-align: center;">
    <button mat-flat-button color="primary" style="margin: 3px;" (click)="save()">
      {{'T4.Service.T4Prices.cmdConfirm' | translate : 'Save' }}
    </button>
</div>
</t4-container>



